import React from 'react'
import styled from 'styled-components'
import logo from '@src/images/logos/brics'

const themeProps = {
  center: {
    "text-align": "center"
  },
  left: {
    "text-align": "left"
  },
  inherit: {
     "text-align": "inherit"
  }
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const Logotype = styled.div`
  background-image: url(${logo});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
  height: 44px;
`

const Description = styled.div`
  text-align: ${(props) => themeProps[props.theme]["text-align"]};
  color: white;
`

const Logo = (props) => {
  const { event } = props

  return (
    <Wrapper className="logotype__wrapper">
      <Logotype className="logotype__logo" />
    </Wrapper>
  )
}

Logo.defaultProps = {
  theme: 'center'
}

export default Logo
